var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [
        _vm._v(
          " 当前状态 " +
            _vm._s(_vm.active ? "开启过渡动画" : "关闭过渡动画") +
            " "
        )
      ]),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              return _vm.set(!_vm.active)
            }
          }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.active ? "关闭页面过渡动画" : "打开页面过渡动画") +
              " "
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }